import { useState } from 'react';
import toast from 'react-hot-toast';

import { IconClose } from '../../../common/icons';
import { useModalDialog } from '../../../common/hooks/use-modal-dialog';
import { useAuth } from '../../../global/contexts/auth/auth';
import { useUpdateUserRole } from '../contexts/users';
import { ROLE_LABEL, assignableRoles } from '../utils/roles';

import './styles/form.css';

// Cambio de rol de un usuario (admin-users.md · PATCH /:id/role, users:admin). Único
// camino de cambio de rol. Los roles ofrecidos se acotan a ≤ el propio (guard Q-169).
export default function RoleModal({ user, onClose, onSaved }) {
    const { permissions } = useAuth();
    const roles = assignableRoles(permissions?.role);
    const { mutateAsync: setUserRole, isPending: busy } = useUpdateUserRole(user.id);
    const cardRef = useModalDialog(onClose);
    const [role, setRole] = useState(user.role);

    const submit = async () => {
        if (role === user.role) { onClose(); return; }
        try {
            await setUserRole(role);
            toast.success('Rol actualizado');
            onSaved?.();
        } catch (er) {
            if (er?.status !== 403) toast.error(er?.message || 'No se pudo cambiar el rol'); // 403 (jerarquía) lo avisa el interceptor
        }
    };

    return (
        <div className="usr-modal" role="dialog" aria-modal="true" aria-label="Cambiar rol">
            <div className="usr-modal__overlay" onClick={onClose} aria-hidden="true" />
            <div className="usr-modal__card usr-modal__card--sm" ref={cardRef}>
                <header className="usr-modal__head">
                    <div>
                        <h2 className="usr-modal__title">Cambiar rol</h2>
                        <span className="usr-modal__sub">{user.name || user.username || user.email}</span>
                    </div>
                    <button type="button" className="usr-modal__close" onClick={onClose} aria-label="Cerrar"><IconClose /></button>
                </header>

                <div className="usr-form">
                    <label className="usr-form__field">
                        <span className="usr-form__label">Rol</span>
                        <select value={role} onChange={(e) => setRole(e.target.value)} disabled={busy}>
                            {/* incluye el rol actual aunque exceda el propio, para no “perderlo” en el select */}
                            {[...new Set([user.role, ...roles])].map((r) => <option key={r} value={r}>{ROLE_LABEL[r] || r}</option>)}
                        </select>
                    </label>
                    <p className="usr-form__note">Cambiar el rol invalida las sesiones previas del usuario.</p>
                </div>

                <footer className="usr-modal__foot">
                    <button type="button" className="usr-btn usr-btn--ghost" onClick={onClose} disabled={busy}>Cancelar</button>
                    <button type="button" className="usr-btn usr-btn--primary" onClick={submit} disabled={busy}>{busy ? 'Guardando…' : 'Guardar rol'}</button>
                </footer>
            </div>
        </div>
    );
}
